import PropTypes from 'prop-types'
import { ICONS } from '../utils/constants'

const Icon = ({ icon, size, color, className, onClick, style }) => {
  const styles = {
    svg: {
      display: 'inline-block',
      color: color,
      ...style,
    },
  }

  function renderPath() {
    switch (icon) {
      case ICONS.CLOSE:
        return (
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4142 12L19.7782 18.364L18.364 19.7782L12 13.4142L5.63604 19.7782L4.22183 18.364L10.5858 12L4.22183 5.63604L5.63604 4.22183L12 10.5858L18.364 4.22183L19.7782 5.63604L13.4142 12Z"
            fill="currentColor"
          />
        )
      case ICONS.USER:
        return (
          <>
            <circle
              cx="8.57881"
              cy="5.77803"
              r="4.77803"
              stroke="#808898"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.00002 17.2014C0.998732 16.8655 1.07385 16.5338 1.2197 16.2312C1.67736 15.3158 2.96798 14.8307 4.03892 14.611C4.81128 14.4462 5.59431 14.3361 6.38217 14.2815C7.84084 14.1534 9.30793 14.1534 10.7666 14.2815C11.5544 14.3367 12.3374 14.4468 13.1099 14.611C14.1808 14.8307 15.4714 15.2701 15.9291 16.2312C16.2224 16.848 16.2224 17.564 15.9291 18.1808C15.4714 19.1419 14.1808 19.5813 13.1099 19.7918C12.3384 19.9635 11.5551 20.0767 10.7666 20.1305C9.57937 20.2311 8.38659 20.2495 7.19681 20.1854C6.92221 20.1854 6.65677 20.1854 6.38217 20.1305C5.59663 20.0773 4.81632 19.9641 4.04807 19.7918C2.96798 19.5813 1.68652 19.1419 1.2197 18.1808C1.0746 17.8747 0.999552 17.5402 1.00002 17.2014Z"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.PRODUCT:
        return (
          <>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.2853 2H19.5519C20.9035 2 21.9998 3.1059 21.9998 4.47018V7.7641C21.9998 9.12735 20.9035 10.2343 19.5519 10.2343H16.2853C14.9328 10.2343 13.8364 9.12735 13.8364 7.7641V4.47018C13.8364 3.1059 14.9328 2 16.2853 2Z"
              stroke="#808898"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.44892 2H7.71449C9.06703 2 10.1634 3.1059 10.1634 4.47018V7.7641C10.1634 9.12735 9.06703 10.2343 7.71449 10.2343H4.44892C3.09638 10.2343 2 9.12735 2 7.7641V4.47018C2 3.1059 3.09638 2 4.44892 2Z"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.44892 13.7656H7.71449C9.06703 13.7656 10.1634 14.8715 10.1634 16.2368V19.5297C10.1634 20.894 9.06703 21.9999 7.71449 21.9999H4.44892C3.09638 21.9999 2 20.894 2 19.5297V16.2368C2 14.8715 3.09638 13.7656 4.44892 13.7656Z"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.2853 13.7656H19.5519C20.9035 13.7656 21.9998 14.8715 21.9998 16.2368V19.5297C21.9998 20.894 20.9035 21.9999 19.5519 21.9999H16.2853C14.9328 21.9999 13.8364 20.894 13.8364 19.5297V16.2368C13.8364 14.8715 14.9328 13.7656 16.2853 13.7656Z"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.PROMOTIONS:
        return (
          <>
            <path
              d="M4.79438 7.05575C4.79438 5.80675 5.80738 4.79375 7.05538 4.79375H8.08438C8.68038 4.79375 9.25338 4.55775 9.67738 4.13675L10.3964 3.41675C11.2774 2.53175 12.7094 2.52775 13.5944 3.40875L13.6034 3.41675L14.3234 4.13675C14.7464 4.55775 15.3194 4.79375 15.9164 4.79375H16.9444C18.1934 4.79375 19.2064 5.80675 19.2064 7.05575V8.08275C19.2064 8.68075 19.4424 9.25275 19.8634 9.67675L20.5834 10.3967C21.4684 11.2777 21.4734 12.7087 20.5924 13.5947L20.5834 13.6037L19.8634 14.3237C19.4424 14.7457 19.2064 15.3197 19.2064 15.9157V16.9447C19.2064 18.1937 18.1934 19.2057 16.9444 19.2057H15.9164C15.3194 19.2057 14.7464 19.4427 14.3234 19.8637L13.6034 20.5827C12.7234 21.4687 11.2914 21.4727 10.4054 20.5917C10.4024 20.5887 10.3994 20.5857 10.3964 20.5827L9.67738 19.8637C9.25338 19.4427 8.68038 19.2057 8.08438 19.2057H7.05538C5.80738 19.2057 4.79438 18.1937 4.79438 16.9447V15.9157C4.79438 15.3197 4.55738 14.7457 4.13638 14.3237L3.41738 13.6037C2.53138 12.7227 2.52738 11.2907 3.40838 10.4057L3.41738 10.3967L4.13638 9.67675C4.55738 9.25275 4.79438 8.68075 4.79438 8.08275V7.05575"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.43018 14.5697L14.5702 9.42969"
              stroke="#808898"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.5669 15.3225C14.3669 15.3225 14.1769 15.2425 14.0369 15.1025C13.9669 15.0325 13.9169 14.9425 13.8769 14.8525C13.8369 14.7625 13.8169 14.6735 13.8169 14.5725C13.8169 14.4725 13.8369 14.3725 13.8769 14.2825C13.9169 14.1925 13.9669 14.1125 14.0369 14.0425C14.3169 13.7625 14.8169 13.7625 15.0969 14.0425C15.1669 14.1125 15.2269 14.1925 15.2669 14.2825C15.2969 14.3725 15.3169 14.4725 15.3169 14.5725C15.3169 14.6735 15.2969 14.7625 15.2669 14.8525C15.2269 14.9425 15.1669 15.0325 15.0969 15.1025C14.9569 15.2425 14.7669 15.3225 14.5669 15.3225Z"
              fill="#808898"
            />
            <path
              d="M9.42676 10.1826C9.32676 10.1826 9.23676 10.1616 9.14676 10.1216C9.05676 10.0816 8.96676 10.0326 8.89676 9.96264C8.82676 9.88264 8.77676 9.80264 8.73676 9.71264C8.69676 9.62164 8.67676 9.53264 8.67676 9.43264C8.67676 9.33164 8.69676 9.23264 8.73676 9.14264C8.77676 9.05264 8.82676 8.96264 8.89676 8.90264C9.18676 8.62164 9.67676 8.62164 9.95676 8.90264C10.0968 9.04164 10.1768 9.23264 10.1768 9.43264C10.1768 9.53264 10.1668 9.62164 10.1268 9.71264C10.0868 9.80264 10.0268 9.88264 9.95676 9.96264C9.88676 10.0326 9.80676 10.0816 9.71676 10.1216C9.62676 10.1616 9.52676 10.1826 9.42676 10.1826Z"
              fill="#808898"
            />
          </>
        )
      case ICONS.BANNERS:
        return (
          <>
            <path
              opacity="0.4"
              d="M13.8499 4.25049V6.67049"
              stroke="#808898"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              opacity="0.4"
              d="M13.8499 17.7603V19.7843"
              stroke="#808898"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              opacity="0.4"
              d="M13.8499 14.3249V9.50391"
              stroke="#808898"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.7022 20C20.5243 20 22.0001 18.5426 22.0001 16.7431V14.1506V12.001V9.85039L21.999 7.25686C21.999 5.45745 20.5222 4 18.7011 4H5.29897C3.47795 4 2.0011 5.45745 2.0011 7.25686L2.00006 9.93485V14.1506V16.7431C2.00006 18.5426 3.47586 20 5.29793 20H18.7022Z"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.SURVEY:
        return (
          <>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.0568 2.00008C8.54687 1.9859 5.28557 3.80704 3.4605 6.80035C1.63543 9.79366 1.51292 13.5223 3.13757 16.6286L3.33789 17.0191C3.50209 17.3264 3.53644 17.6864 3.43329 18.0191C3.14742 18.7784 2.90849 19.5544 2.71784 20.3429C2.71784 20.7429 2.83231 20.9715 3.26158 20.962C4.0219 20.7941 4.77068 20.5777 5.50332 20.3143C5.81886 20.2274 6.15437 20.2475 6.45725 20.3715C6.73389 20.5048 7.2967 20.8477 7.31578 20.8477C10.9915 22.7804 15.4808 22.2472 18.5998 19.5074C21.7187 16.7676 22.8199 12.39 21.3676 8.50403C19.9153 4.61809 16.2111 2.03053 12.0568 2.00008V2.00008Z"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <ellipse
              cx="7.28727"
              cy="12.0001"
              rx="0.476965"
              ry="0.47619"
              fill="#808898"
              stroke="#808898"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <ellipse
              cx="12.0568"
              cy="12.0001"
              rx="0.476965"
              ry="0.47619"
              fill="#808898"
              stroke="#808898"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <ellipse
              cx="16.8266"
              cy="12.0001"
              rx="0.476965"
              ry="0.47619"
              fill="#808898"
              stroke="#808898"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.ORDERS:
        return (
          <>
            <path
              opacity="0.4"
              d="M7.24487 14.781L10.238 10.8909L13.6522 13.5728L16.5813 9.79248"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle
              cx="19.9954"
              cy="4.20003"
              r="1.9222"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.9245 3.12012H7.65679C4.64535 3.12012 2.77808 5.25284 2.77808 8.26428V16.3467C2.77808 19.3581 4.60874 21.4817 7.65679 21.4817H16.2609C19.2724 21.4817 21.1396 19.3581 21.1396 16.3467V9.30776"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.USERS:
        return (
          <>
            <path
              d="M17.595 10.9319C19.1973 10.9319 20.4971 9.63298 20.4971 8.03064C20.4971 6.42831 19.1973 5.12939 17.595 5.12939"
              stroke="#808898"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.9292 14.085C19.4077 14.118 19.8834 14.1858 20.3519 14.2912C21.0027 14.4186 21.7855 14.6854 22.0642 15.2693C22.242 15.6433 22.242 16.0787 22.0642 16.4536C21.7864 17.0375 21.0027 17.3034 20.3519 17.4372"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.29011 10.9319C4.68777 10.9319 3.38794 9.63298 3.38794 8.03064C3.38794 6.42831 4.68777 5.12939 6.29011 5.12939"
              stroke="#808898"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.95589 14.085C4.47739 14.118 4.00164 14.1858 3.53322 14.2912C2.88239 14.4186 2.09956 14.6854 1.82181 15.2693C1.64306 15.6433 1.64306 16.0787 1.82181 16.4536C2.09864 17.0375 2.88239 17.3034 3.53322 17.4372"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.9379 14.7095C15.1847 14.7095 17.9586 15.2008 17.9586 17.1671C17.9586 19.1324 15.2031 19.6421 11.9379 19.6421C8.69015 19.6421 5.91724 19.1507 5.91724 17.1845C5.91724 15.2182 8.67274 14.7095 11.9379 14.7095Z"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.9378 11.9049C9.79651 11.9049 8.07959 10.188 8.07959 8.04575C8.07959 5.90442 9.79651 4.1875 11.9378 4.1875C14.0792 4.1875 15.7961 5.90442 15.7961 8.04575C15.7961 10.188 14.0792 11.9049 11.9378 11.9049Z"
              stroke="#808898"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.NOTIFICATIONS:
        return (
          <>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.00083 13.7871V13.5681C4.03295 12.9202 4.2406 12.2925 4.60236 11.7496C5.2045 11.0975 5.6167 10.2983 5.79571 9.43598C5.79571 8.7695 5.79571 8.0935 5.85393 7.42703C6.15469 4.21842 9.32728 2 12.4611 2H12.5387C15.6725 2 18.845 4.21842 19.1555 7.42703C19.2137 8.0935 19.1555 8.7695 19.204 9.43598C19.3854 10.3003 19.7972 11.1019 20.3974 11.7591C20.7618 12.2972 20.9698 12.9227 20.9989 13.5681V13.7776C21.0206 14.648 20.7208 15.4968 20.1548 16.1674C19.407 16.9515 18.3921 17.4393 17.3024 17.5384C14.107 17.8812 10.883 17.8812 7.68762 17.5384C6.59914 17.435 5.58576 16.9479 4.83521 16.1674C4.278 15.4963 3.98224 14.6526 4.00083 13.7871Z"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              opacity="0.4"
              d="M10.0549 20.7954C10.5542 21.4221 11.2874 21.8277 12.0922 21.9224C12.8971 22.0171 13.7072 21.7931 14.3433 21.3C14.5389 21.1542 14.7149 20.9846 14.8672 20.7954"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.EXIT:
        return (
          <>
            <path
              d="M15.016 7.38948V6.45648C15.016 4.42148 13.366 2.77148 11.331 2.77148H6.45597C4.42197 2.77148 2.77197 4.42148 2.77197 6.45648V17.5865C2.77197 19.6215 4.42197 21.2715 6.45597 21.2715H11.341C13.37 21.2715 15.016 19.6265 15.016 17.5975V16.6545"
              stroke="#DB0000"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.8096 12.0215H9.76855"
              stroke="#DB0000"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.8811 9.10645L21.8091 12.0214L18.8811 14.9374"
              stroke="#DB0000"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.ALERT:
        return (
          <>
            <path
              d="M3.48387 3.53226C5.83871 1.17742 8.67742 0 12 0C15.3226 0 18.1452 1.17742 20.4677 3.53226C22.8226 5.85484 24 8.67742 24 12C24 15.3226 22.8226 18.1613 20.4677 20.5161C18.1452 22.8387 15.3226 24 12 24C8.67742 24 5.83871 22.8387 3.48387 20.5161C1.16129 18.1613 0 15.3226 0 12C0 8.67742 1.16129 5.85484 3.48387 3.53226ZM18.8226 5.17742C16.9516 3.27419 14.6774 2.32258 12 2.32258C9.32258 2.32258 7.03226 3.27419 5.12903 5.17742C3.25806 7.04839 2.32258 9.32258 2.32258 12C2.32258 14.6774 3.25806 16.9677 5.12903 18.871C7.03226 20.7419 9.32258 21.6774 12 21.6774C14.6774 21.6774 16.9516 20.7419 18.8226 18.871C20.7258 16.9677 21.6774 14.6774 21.6774 12C21.6774 9.32258 20.7258 7.04839 18.8226 5.17742Z"
              fill="#DB0000"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.2258 14.6129C12.8387 14.6129 13.3548 14.8387 13.7742 15.2903C14.2258 15.7097 14.4516 16.2258 14.4516 16.8387C14.4516 17.4516 14.2258 17.9839 13.7742 18.4355C13.3548 18.8548 12.8387 19.0645 12.2258 19.0645C11.6129 19.0645 11.0806 18.8548 10.629 18.4355C10.2097 17.9839 10 17.4516 10 16.8387C10 16.2258 10.2097 15.7097 10.629 15.2903C11.0806 14.8387 11.6129 14.6129 12.2258 14.6129ZM10.4839 13.2097L10.0968 6.62903C10.0968 6.43548 10.1452 6.29032 10.2419 6.19355C10.371 6.06452 10.5161 6 10.6774 6H13.7742C13.9355 6 14.0645 6.06452 14.1613 6.19355C14.2903 6.29032 14.3548 6.43548 14.3548 6.62903L13.9677 13.2097C13.9677 13.5645 13.7742 13.7419 13.3871 13.7419H11.0645C10.6774 13.7419 10.4839 13.5645 10.4839 13.2097Z"
              fill="#DB0000"
            />
          </>
        )
      case ICONS.PLUS:
        return (
          <path
            d="M7.90553 11.0942C7.40547 11.0942 7.00005 11.4998 7 12.0003C6.99995 12.5007 7.40528 12.9064 7.90534 12.9065L11.0946 12.9068V16.0939C11.0946 16.5943 11.5 17 12.0001 17C12.5001 17 12.9055 16.5943 12.9055 16.0939V12.907L16.0945 12.9074C16.5945 12.9074 16.9999 12.5018 17 12.0013C17.0001 11.5009 16.5947 11.0951 16.0947 11.0951L12.9055 11.0948V7.90613C12.9055 7.40569 12.5001 7 12.0001 7C11.5 7 11.0946 7.40569 11.0946 7.90614V11.0946L7.90553 11.0942Z"
            fill="currentColor"
          />
        )
      case ICONS.SEARCH:
        return (
          <>
            <circle
              cx="11.7664"
              cy="11.7666"
              r="8.98856"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              opacity="0.4"
              d="M18.0181 18.4851L21.5421 22"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.ASCEND:
        return (
          <path
            d="M11.0263 11.5758V12.7071H15.478V11.5758H11.0263ZM11.0263 8.18182V9.31314H13.2521V8.18182H11.0263ZM11.0263 14.9697V16.101H17.7038V14.9697H11.0263ZM8.80045 9.31314H10.1916L8.24399 7.33334L6.29639 9.31314H7.68753V16.6667H8.80045V9.31314Z"
            fill="currentColor"
          />
        )
      case ICONS.DESCEND:
        return (
          <path
            d="M11.0263 12.4242V11.2929H15.478V12.4242H11.0263ZM11.0263 15.8182V14.6869H13.2521V15.8182H11.0263ZM11.0263 9.0303V7.89898H17.7038V9.0303H11.0263ZM8.80045 14.6869H10.1916L8.24399 16.6667L6.29639 14.6869H7.68753V7.33333H8.80045V14.6869Z"
            fill="currentColor"
          />
        )
      case ICONS.ARROW_LEFT:
        return (
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5371 22.0827L6.29215 12.9458C5.90262 12.5612 5.90262 11.9398 6.29215 11.5542L15.5371 2.41733C16.0995 1.86089 17.0144 1.86089 17.5777 2.41733C18.14 2.97378 18.14 3.87687 17.5777 4.43332L9.66913 12.2505L17.5777 20.0657C18.14 20.6231 18.14 21.5262 17.5777 22.0827C17.0144 22.6391 16.0995 22.6391 15.5371 22.0827"
            fill="currentColor"
          />
        )
      case ICONS.DUPLICATE:
        return (
          <>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.56152 5.83442C6.56152 3.69329 8.24662 2 10.1742 2H16.3877C18.3153 2 20.0004 3.69329 20.0004 5.83442V15.0057C20.0004 17.0847 18.456 18.9959 16.4704 18.9959H10.1742C8.11843 18.9959 6.56152 17.2064 6.56152 15.0057V5.83442ZM10.1742 3.28413C8.85638 3.28413 7.74369 4.44846 7.74369 5.83442V15.0057C7.74369 16.5307 8.80173 17.7118 10.1742 17.7118H16.4704C17.7318 17.7118 18.8182 16.4555 18.8182 15.0057V5.83442C18.8182 4.44846 17.7055 3.28413 16.3877 3.28413H10.1742Z"
              fill="#200E32"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.59108 8.19653C4.91753 8.19653 5.18216 8.484 5.18216 8.8386V18.0099C5.18216 19.5349 6.2402 20.716 7.61269 20.716H13.9089C14.2353 20.716 14.5 21.0034 14.5 21.358C14.5 21.7126 14.2353 22.0001 13.9089 22.0001H7.61269C5.55691 22.0001 4 20.2106 4 18.0099V8.8386C4 8.484 4.26464 8.19653 4.59108 8.19653Z"
              fill="#808898"
            />
          </>
        )
      case ICONS.DELETE:
        return (
          <>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.07373 8.72059C5.48661 8.6874 5.84822 8.9952 5.88142 9.40808L4.38624 9.52828C4.35305 9.1154 4.66085 8.75378 5.07373 8.72059ZM8.26402 21.959C7.45091 21.9423 6.7254 21.6814 6.17839 21.1601C5.63483 20.642 5.33383 19.9302 5.24539 19.1297M8.26402 21.959C9.67595 21.9888 11.0887 22.0016 12.501 21.9998C12.9152 21.9992 13.2506 21.663 13.25 21.2488C13.2495 20.8345 12.9133 20.4992 12.499 20.4998C11.0971 20.5016 9.69559 20.4889 8.29564 20.4593C7.78993 20.449 7.44416 20.2943 7.21327 20.0743C6.97888 19.8509 6.79488 19.4953 6.7363 18.9648C6.57898 17.5445 6.36544 15.1585 6.19071 13.1204C6.10349 12.1029 6.02615 11.1747 5.97062 10.5008C5.94286 10.1639 5.92055 9.89064 5.90518 9.70162L5.88142 9.40808L4.38624 9.52828L4.41012 9.82316C4.42552 10.0127 4.44788 10.2865 4.47569 10.624C4.53132 11.299 4.60879 12.229 4.69619 13.2485C4.87071 15.2842 5.08571 17.6881 5.24539 19.1297"
              fill="#808898"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.93 8.72059C18.5171 8.6874 18.1555 8.9952 18.1223 9.40808L19.6175 9.52828C19.6507 9.1154 19.3429 8.75378 18.93 8.72059ZM15.7397 21.959C16.5528 21.9423 17.2784 21.6814 17.8254 21.1601C18.3689 20.642 18.6699 19.9302 18.7584 19.1297M15.7397 21.959C14.3278 21.9888 12.9151 22.0016 11.5027 21.9998C11.0885 21.9992 10.7532 21.663 10.7537 21.2488C10.7543 20.8345 11.0905 20.4992 11.5047 20.4998C12.9067 20.5016 14.3082 20.4889 15.7081 20.4593C16.2138 20.449 16.5596 20.2943 16.7905 20.0743C17.0249 19.8509 17.2089 19.4953 17.2675 18.9648C17.4248 17.5445 17.6383 15.1585 17.813 13.1204C17.9003 12.1029 17.9776 11.1747 18.0331 10.5008C18.0609 10.1639 18.0832 9.89064 18.0986 9.70162L18.1223 9.40808L19.6175 9.52828L19.5936 9.82316C19.5782 10.0127 19.5559 10.2865 19.5281 10.624C19.4724 11.299 19.395 12.229 19.3076 13.2485C19.133 15.2842 18.918 17.6881 18.7584 19.1297"
              fill="#808898"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.76953 6.23973C2.76953 5.82552 3.10532 5.48973 3.51953 5.48973H20.4775C20.8917 5.48973 21.2275 5.82552 21.2275 6.23973C21.2275 6.65395 20.8917 6.98973 20.4775 6.98973H3.51953C3.10532 6.98973 2.76953 6.65395 2.76953 6.23973Z"
              fill="#200E32"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.92038 3.506C8.15842 2.61573 8.96457 2.00073 9.88193 2.00073H14.1149C15.0323 2.00073 15.8384 2.61573 16.0765 3.506C16.0806 3.52147 16.0843 3.53706 16.0874 3.55276L16.3303 4.76846V4.76846C16.4143 5.18726 16.7829 5.48973 17.2099 5.48973C17.6241 5.48973 17.9599 5.82552 17.9599 6.23973C17.9599 6.65395 17.6241 6.98973 17.2099 6.98973C16.067 6.98973 15.0836 6.18205 14.8595 5.063L14.6222 3.87534C14.5544 3.65339 14.3492 3.50073 14.1149 3.50073H9.88193C9.64762 3.50073 9.44249 3.65339 9.37467 3.87534L9.13739 5.0627C8.91329 6.18175 7.92981 6.98973 6.78693 6.98973C6.37272 6.98973 6.03693 6.65395 6.03693 6.23973C6.03693 5.82552 6.37272 5.48973 6.78693 5.48973C7.21395 5.48973 7.58246 5.18756 7.66647 4.76876L7.90947 3.55276C7.91261 3.53706 7.91625 3.52147 7.92038 3.506Z"
              fill="#200E32"
            />
          </>
        )
      case ICONS.VISIBLE:
        return (
          <>
            <path
              d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.INVISIBLE:
        return (
          <>
            <path
              d="M9.9 4.23999C10.5883 4.07887 11.2931 3.99833 12 3.99999C19 3.99999 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19M14.12 14.12C13.8454 14.4147 13.5141 14.6511 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1961C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4858 9.58525 10.1546 9.88 9.87999M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68189 3.96914 7.6566 6.06 6.05999L17.94 17.94Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 1L23 23"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.TRASH:
        return (
          <>
            <path
              d="M3 6H5H21"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 11V17"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14 11V17"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.EYE:
        return (
          <path
            d="M19.7857 12.4643C18.1635 14.9688 15.5452 16.7143 12.5 16.7143C9.4548 16.7143 6.8365 14.9688 5.21429 12.4643C6.11551 11.0698 7.34877 9.87444 8.82868 9.11551C8.44922 9.7606 8.25 10.5006 8.25 11.25C8.25 13.5932 10.1568 15.5 12.5 15.5C14.8432 15.5 16.75 13.5932 16.75 11.25C16.75 10.5006 16.5508 9.7606 16.1713 9.11551C17.6512 9.87444 18.8845 11.0698 19.7857 12.4643ZM12.9554 8.82143C12.9554 9.06808 12.7467 9.27679 12.5 9.27679C11.4185 9.27679 10.5268 10.1685 10.5268 11.25C10.5268 11.4967 10.3181 11.7054 10.0714 11.7054C9.82478 11.7054 9.61607 11.4967 9.61607 11.25C9.61607 9.66574 10.9157 8.36607 12.5 8.36607C12.7467 8.36607 12.9554 8.57478 12.9554 8.82143ZM21 12.4643C21 12.2271 20.9241 12.0089 20.8103 11.8097C19.0647 8.94475 15.8677 7 12.5 7C9.13225 7 5.93527 8.94475 4.18973 11.8097C4.07589 12.0089 4 12.2271 4 12.4643C4 12.7015 4.07589 12.9196 4.18973 13.1189C5.93527 15.9838 9.13225 17.9286 12.5 17.9286C15.8677 17.9286 19.0647 15.9933 20.8103 13.1189C20.9241 12.9196 21 12.7015 21 12.4643Z"
            fill="currentColor"
          />
        )
      case ICONS.UPLOAD:
        return (
          <>
            <path
              d="M12.1221 15.436L12.1221 3.39502"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.0381 12.5083L12.1221 15.4363L9.20609 12.5083"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.7551 8.12793H17.6881C19.7231 8.12793 21.3721 9.77693 21.3721 11.8129V16.6969C21.3721 18.7269 19.7271 20.3719 17.6971 20.3719L6.55707 20.3719C4.52207 20.3719 2.87207 18.7219 2.87207 16.6869V11.8019C2.87207 9.77293 4.51807 8.12793 6.54707 8.12793L7.48907 8.12793"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.IMAGE:
        return (
          <path
            d="M12.652 11.9288L10.7417 14.3645L9.73259 13.0779C9.71421 13.0544 9.69074 13.0354 9.66394 13.0224C9.63714 13.0093 9.60771 13.0025 9.5779 13.0025C9.54809 13.0025 9.51867 13.0093 9.49187 13.0224C9.46507 13.0354 9.44159 13.0544 9.42321 13.0779L6.97277 16.2011C6.9501 16.2301 6.93603 16.2648 6.93218 16.3014C6.92832 16.3379 6.93483 16.3749 6.95097 16.4079C6.96711 16.4409 6.99221 16.4688 7.02342 16.4882C7.05463 16.5077 7.09068 16.5179 7.12746 16.5179H16.1607C16.3252 16.5179 16.4161 16.3288 16.3154 16.2011L12.9638 11.9288C12.9452 11.9053 12.9215 11.8863 12.8945 11.8732C12.8675 11.8602 12.8379 11.8534 12.8079 11.8534C12.7779 11.8534 12.7483 11.8602 12.7213 11.8732C12.6943 11.8863 12.6706 11.9053 12.652 11.9288V11.9288ZM7.91071 10.2812C7.91071 10.5417 8.01419 10.7915 8.19838 10.9757C8.38256 11.1599 8.63238 11.2634 8.89286 11.2634C9.15334 11.2634 9.40315 11.1599 9.58734 10.9757C9.77152 10.7915 9.875 10.5417 9.875 10.2812C9.875 10.0208 9.77152 9.77096 9.58734 9.58677C9.40315 9.40258 9.15334 9.29911 8.89286 9.29911C8.63238 9.29911 8.38256 9.40258 8.19838 9.58677C8.01419 9.77096 7.91071 10.0208 7.91071 10.2812ZM20.0549 6.51473L14.771 1.2308C14.6237 1.08348 14.4248 1 14.2161 1H3.78571C3.35112 1 3 1.35112 3 1.78571V22.2143C3 22.6489 3.35112 23 3.78571 23H19.5C19.9346 23 20.2857 22.6489 20.2857 22.2143V7.0721C20.2857 6.86339 20.2022 6.66205 20.0549 6.51473ZM18.4737 7.43304H13.8527V2.81205L18.4737 7.43304ZM18.5179 21.2321H4.76786V2.76786H12.183V8.07143C12.183 8.34493 12.2917 8.60724 12.4851 8.80063C12.6785 8.99403 12.9408 9.10268 13.2143 9.10268H18.5179V21.2321Z"
            fill="currentColor"
          />
        )
      case ICONS.PLAY:
        return (
          <>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 3.66666C16.6024 3.66666 20.3334 7.39763 20.3334 12C20.3334 16.6024 16.6024 20.3333 12 20.3333C7.39766 20.3333 3.66669 16.6024 3.66669 12C3.66669 7.39763 7.39766 3.66666 12 3.66666Z"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              opacity="0.4"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.5418 12.3891C13.9343 13.0441 12.2809 14.1524 11.4351 14.5082C11.3001 14.5649 10.9559 14.6849 10.8818 14.6866C10.7243 14.6916 10.5726 14.6032 10.4993 14.4616C10.4709 14.4066 10.3876 14.0474 10.3609 13.8874C10.2818 13.4007 10.2409 12.6449 10.2418 11.8849C10.2409 11.0874 10.2851 10.2957 10.3734 9.81408C10.3968 9.68408 10.4651 9.38491 10.4851 9.33658C10.5226 9.24658 10.5909 9.17575 10.6734 9.13158C10.7368 9.09741 10.8093 9.07908 10.8818 9.08158C10.9559 9.08324 11.2576 9.18908 11.3609 9.22991C12.1759 9.54658 13.9001 10.6949 14.5334 11.3699C14.5901 11.4307 14.7459 11.5941 14.7718 11.6274C14.8309 11.7024 14.8601 11.7932 14.8601 11.8849C14.8601 11.9699 14.8343 12.0566 14.7809 12.1291C14.7534 12.1666 14.5943 12.3332 14.5418 12.3891Z"
              stroke="#200E32"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.MENU_OUTLINED:
        return (
          <>
            <rect fill="#767676" x="2" y="3" width="20" height="2"></rect>
            <rect fill="#767676" x="2" y="11" width="20" height="2"></rect>
            <rect fill="#767676" x="2" y="19" width="20" height="2"></rect>
          </>
        )
      case ICONS.MOSQUE:
        return (
          <>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.75 6C20.75 5.58579 20.4142 5.25 20 5.25C19.5858 5.25 19.25 5.58579 19.25 6V6.35352C18.0957 6.67998 17.25 7.74122 17.25 9L19.125 11.75H20.25V20.25H10C9.58579 20.25 9.25 20.5858 9.25 21C9.25 21.4142 9.58579 21.75 10 21.75H21C21.4142 21.75 21.75 21.4142 21.75 21V11.75H22C22.4142 11.75 22.75 11.4142 22.75 11V9C22.75 7.74122 21.9043 6.67998 20.75 6.35352V6ZM21.25 9V10.25H18.75V9C18.75 8.30964 19.3096 7.75 20 7.75C20.6904 7.75 21.25 8.30964 21.25 9Z"
              fill="currentColor"
            />
            <path
              d="M17.25 11C17.25 11.4142 17.5858 11.75 18 11.75H19.125L17.25 9V11Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.25 6C3.25 5.58579 3.58579 5.25 4 5.25C4.41421 5.25 4.75 5.58579 4.75 6V6.35352C5.90425 6.67998 6.75 7.74122 6.75 9L4.875 11.75H3.75V20.25H14C14.4142 20.25 14.75 20.5858 14.75 21C14.75 21.4142 14.4142 21.75 14 21.75H3C2.58579 21.75 2.25 21.4142 2.25 21V11.75H2C1.58579 11.75 1.25 11.4142 1.25 11V9C1.25 7.74122 2.09575 6.67998 3.25 6.35352V6ZM2.75 9V10.25H5.25V9C5.25 8.30964 4.69036 7.75 4 7.75C3.30964 7.75 2.75 8.30964 2.75 9Z"
              fill="currentColor"
            />
            <path
              d="M6.75 11C6.75 11.4142 6.41421 11.75 6 11.75H4.875L6.75 9V11Z"
              fill="currentColor"
            />
            <path
              opacity="0.4"
              d="M12 9C10.5 9 10.5 12.5 10.5 12.5H13.5C13.5 12.5 13.5 9 12 9Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              opacity="0.4"
              d="M12 15C10 15 10 21 10 21H14C14 21 14 15 12 15Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 3V6M12 6V6C8.68629 6 6 8.68629 6 12V21H18V12C18 8.68629 15.3137 6 12 6V6Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.RATING:
        return (
          <>
            <g opacity="0.4">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 17V7H11V17H7Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13 17V11H17V17H13Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <path
              d="M7.78265 3H16.2173C19.1695 3 21 5.09073 21 8.04287V15.9661C21 18.9182 19.1695 21 16.2173 21H7.78265C4.79462 21 3 18.9182 3 15.9661V8.04287C3 5.09073 4.83051 3 7.78265 3Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.COUPON:
        return (
          <>
            <path
              d="M7.25679 22.0001C5.45739 22.0001 3.99994 20.5243 3.99994 18.7022L3.99994 5.29793C3.99994 3.47586 5.45739 2.00006 7.25679 2.00006L9.8493 2.00006L14.0651 2.00006L16.7431 2.0011C18.5425 2.0011 19.9999 3.47795 19.9999 5.29897L19.9999 18.7011C19.9999 20.5222 18.5425 21.999 16.7431 21.999L11.9989 17.0001L7.25679 22.0001Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <g opacity="0.4">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.2713 5.38318C16.5642 5.67607 16.5642 6.15094 16.2713 6.44384L8.7889 13.9262C8.49601 14.2191 8.02114 14.2191 7.72824 13.9262C7.43535 13.6334 7.43535 13.1585 7.72824 12.8656L15.2107 5.38318C15.5035 5.09028 15.9784 5.09028 16.2713 5.38318Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.405 12.31C14.9908 12.31 14.655 12.6458 14.655 13.06C14.655 13.4742 14.9908 13.81 15.405 13.81C15.8192 13.81 16.155 13.4742 16.155 13.06C16.155 12.6458 15.8192 12.31 15.405 12.31ZM13.155 13.06C13.155 11.8174 14.1623 10.81 15.405 10.81C16.6476 10.81 17.655 11.8174 17.655 13.06C17.655 14.3026 16.6476 15.31 15.405 15.31C14.1623 15.31 13.155 14.3026 13.155 13.06Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.59497 5.5C8.18076 5.5 7.84497 5.83579 7.84497 6.25C7.84497 6.66421 8.18076 7 8.59497 7C9.00918 7 9.34497 6.66421 9.34497 6.25C9.34497 5.83579 9.00918 5.5 8.59497 5.5ZM6.34497 6.25C6.34497 5.00736 7.35233 4 8.59497 4C9.83761 4 10.845 5.00736 10.845 6.25C10.845 7.49264 9.83761 8.5 8.59497 8.5C7.35233 8.5 6.34497 7.49264 6.34497 6.25Z"
                fill="currentColor"
              />
            </g>
          </>
        )
      case ICONS.STAR_EMPTY:
        return (
          <>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.0323 3.25907C12.012 3.24884 11.989 3.24721 11.9676 3.25443L11.9645 3.25544C11.9465 3.26144 11.9302 3.27525 11.9212 3.29388L11.9182 3.30004L9.47918 8.21403L9.47765 8.21709C9.24621 8.67809 8.80605 8.9995 8.29857 9.0819L8.28596 9.08394L2.84262 9.87271C2.81595 9.87835 2.78931 9.89016 2.76527 9.90803C2.74258 9.93995 2.74552 9.98307 2.77179 10.0113L6.74986 13.8456L6.75277 13.8484C7.12505 14.2111 7.29424 14.7347 7.20657 15.2455L7.20602 15.2486L6.25402 20.656C6.25193 20.6706 6.25387 20.6869 6.26011 20.702C6.28887 20.7447 6.34295 20.7587 6.38717 20.7381L11.2741 18.176C11.7385 17.9248 12.2972 17.9256 12.761 18.1756L17.6166 20.7202C17.6419 20.7321 17.6709 20.7368 17.6999 20.7331C17.7392 20.7251 17.7677 20.689 17.7639 20.6457L16.8147 15.254C16.7171 14.7376 16.8896 14.2049 17.2721 13.8435L21.2313 9.99841C21.2547 9.97646 21.2579 9.93863 21.2384 9.91318L21.2358 9.90981C21.2207 9.88992 21.2 9.87887 21.1798 9.87621L21.1698 9.8749L15.708 9.08328C15.1926 9.00589 14.7475 8.68114 14.5176 8.21206L12.0832 3.30742C12.0716 3.28614 12.0546 3.27025 12.035 3.26041L12.0323 3.25907ZM12.7071 1.91942C12.3286 1.72875 11.8915 1.69829 11.4922 1.83174C11.0895 1.96534 10.7585 2.25615 10.5733 2.63582L8.1371 7.54409C8.13724 7.54383 8.13697 7.54435 8.1371 7.54409C8.12287 7.57181 8.09427 7.5943 8.06144 7.6007L2.61281 8.39034C2.60575 8.39137 2.59872 8.39249 2.5917 8.39371C2.27065 8.44962 1.97589 8.59691 1.73966 8.81182C1.73093 8.81977 1.72239 8.82791 1.71405 8.83626C1.71283 8.83747 1.71162 8.83868 1.71042 8.83989C1.09529 9.45882 1.09629 10.4591 1.71486 11.0757L5.70598 14.9228C5.70576 14.9225 5.7062 14.923 5.70598 14.9228C5.72309 14.9399 5.73229 14.9663 5.72831 14.991C5.72835 14.9907 5.72827 14.9912 5.72831 14.991L4.77574 20.4015L4.77447 20.409C4.71738 20.7534 4.77642 21.1053 4.93713 21.4097L4.94538 21.4249C5.36163 22.1712 6.29401 22.4646 7.06475 22.0764L11.9756 19.5018L11.9875 19.4955C12.0056 19.4855 12.0287 19.4848 12.0494 19.4961L16.9283 22.0529L16.9394 22.0586C17.2462 22.2129 17.5944 22.2677 17.9349 22.2146L17.9419 22.2135C18.7934 22.0726 19.3726 21.2761 19.2474 20.4228C19.2464 20.4157 19.2453 20.4086 19.244 20.4015L18.291 14.9885L18.2886 14.9757C18.2858 14.9612 18.2911 14.9441 18.3026 14.9334L18.3129 14.9236L22.2629 11.0875C22.8434 10.538 22.9151 9.63775 22.431 9.00337C22.1772 8.66879 21.8002 8.44636 21.3807 8.38974L15.9308 7.59991C15.9311 7.59996 15.9305 7.59986 15.9308 7.59991C15.9015 7.59521 15.8767 7.57697 15.8644 7.55172L13.4232 2.63315L13.4181 2.62302C13.262 2.32011 13.014 2.0732 12.7071 1.91942ZM1.62404 8.94493C1.62914 8.93739 1.6367 8.92653 1.64679 8.91332C1.63788 8.92504 1.63032 8.93571 1.62404 8.94493ZM1.61003 8.96626C1.61247 8.96242 1.61562 8.95753 1.61896 8.9525L1.61003 8.96626ZM1.60564 8.97327C1.60432 8.9754 1.60597 8.97268 1.60915 8.96766L1.60564 8.97327Z"
              fill="currentColor"
            />
          </>
        )
      case ICONS.SETTINGS:
        return (
          <>
            <path
              d="M4.79432 7.05575C4.79432 5.80675 5.80732 4.79375 7.05532 4.79375H8.08432C8.68032 4.79375 9.25332 4.55775 9.67732 4.13675L10.3963 3.41675C11.2773 2.53175 12.7093 2.52775 13.5943 3.40875L13.6033 3.41675L14.3233 4.13675C14.7463 4.55775 15.3193 4.79375 15.9163 4.79375H16.9443C18.1933 4.79375 19.2063 5.80675 19.2063 7.05575V8.08275C19.2063 8.68075 19.4423 9.25275 19.8633 9.67675L20.5833 10.3967C21.4683 11.2777 21.4733 12.7087 20.5923 13.5947L20.5833 13.6037L19.8633 14.3237C19.4423 14.7457 19.2063 15.3197 19.2063 15.9157V16.9447C19.2063 18.1937 18.1933 19.2057 16.9443 19.2057H15.9163C15.3193 19.2057 14.7463 19.4427 14.3233 19.8637L13.6033 20.5827C12.7233 21.4687 11.2913 21.4727 10.4053 20.5917C10.4023 20.5887 10.3993 20.5857 10.3963 20.5827L9.67732 19.8637C9.25332 19.4427 8.68032 19.2057 8.08432 19.2057H7.05532C5.80732 19.2057 4.79432 18.1937 4.79432 16.9447V15.9157C4.79432 15.3197 4.55732 14.7457 4.13632 14.3237L3.41732 13.6037C2.53132 12.7227 2.52732 11.2907 3.40832 10.4057L3.41732 10.3967L4.13632 9.67675C4.55732 9.25275 4.79432 8.68075 4.79432 8.08275V7.05575"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle
              opacity="0.4"
              cx="12"
              cy="12"
              r="3"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.CHEVRON_UP:
        return (
          <path
            d="M17 14.5L12 9.5L7 14.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        )
      case ICONS.CHEVRON_DOWN:
        return (
          <path
            d="M17 9.5L12 14.5L7 9.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        )
      case ICONS.CHEVRON_LEFT:
        return (
          <path
            d="M14 17L9 12L14 7"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        )
      case ICONS.CHEVRON_RIGHT:
        return (
          <path
            d="M9 7L14 12L9 17"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        )
      case ICONS.DOWNLOAD:
        return (
          <>
            <path
              d="M12.1211 15.436L12.1211 3.39502"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.0391 12.5083L12.1231 15.4363L9.20706 12.5083"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.7541 8.12793H17.6871C19.7221 8.12793 21.3711 9.77693 21.3711 11.8129V16.6969C21.3711 18.7269 19.7261 20.3719 17.6961 20.3719L6.55609 20.3719C4.52109 20.3719 2.87109 18.7219 2.87109 16.6869V11.8019C2.87109 9.77293 4.51709 8.12793 6.54609 8.12793L7.48809 8.12793"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.MORE:
        return (
          <>
            <circle
              cx="12"
              cy="12"
              r="1"
              fill="#475467"
              stroke="#475467"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle
              cx="12"
              cy="19"
              r="1"
              fill="#475467"
              stroke="#475467"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle
              cx="12"
              cy="5"
              r="1"
              fill="#475467"
              stroke="#475467"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.EDIT:
        return (
          <>
            <path
              d="M15 5.9997L18 8.9997M13 19.9997H21M5 15.9997L4 19.9997L8 18.9997L19.586 7.4137C19.9609 7.03864 20.1716 6.53003 20.1716 5.9997C20.1716 5.46937 19.9609 4.96075 19.586 4.5857L19.414 4.4137C19.0389 4.03876 18.5303 3.82812 18 3.82812C17.4697 3.82813 16.9611 4.03876 16.586 4.4137L5 15.9997Z"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )
      case ICONS.CUSTOMERS_NEW:
        return (
          <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 19.9999L3.00569 20C3.00499 18.0127 2.50691 13.5419 11 14.0382"
                stroke="black"
                stroke-width="1.5"
              />
              <circle cx="12" cy="7" r="4.25" stroke="black" stroke-width="1.5" />
              <path d="M17.5 13.5V21" stroke="#808898" stroke-width="1.5" stroke-linecap="round" />
              <path
                d="M21.25 17.25L13.75 17.25"
                stroke="#808898"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </>
        )
      case ICONS.ROLES:
        return (
          <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.6667 14H14.3333L13 16.625L17 21L21 16.625L19.6667 14Z"
                stroke="#808898"
                stroke-width="1.5"
              />
              <path
                d="M12 19.9999L3.00569 20C3.00499 18.0127 2.50691 13.5419 11 14.0382"
                stroke="black"
                stroke-width="1.5"
              />
              <circle cx="12" cy="7" r="4.25" stroke="black" stroke-width="1.5" />
            </svg>
          </>
        )
      case ICONS.LOGS:
        return (
          <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.0289 2H12.9793C14.6767 2 16.0213 2 17.0732 2.14233C18.1555 2.2893 19.0319 2.59814 19.7236 3.29395C19.846 3.42621 19.9126 3.60114 19.9094 3.78188C19.9063 3.96263 19.8336 4.13508 19.7067 4.2629C19.5798 4.39073 19.4086 4.46395 19.2291 4.46714C19.0497 4.47033 18.876 4.40324 18.7447 4.28C18.3532 3.88744 17.8175 3.65116 16.8885 3.52558C15.9401 3.39721 14.6887 3.39535 12.9276 3.39535H11.0806C9.31951 3.39535 8.06909 3.39721 7.11881 3.52558C6.19069 3.65116 5.65506 3.88744 5.26442 4.28093C4.87378 4.67442 4.63921 5.21395 4.51454 6.14884C4.3871 7.10605 4.38525 8.36558 4.38525 10.1395V13.8605C4.38525 15.6344 4.3871 16.8949 4.51454 17.8512C4.63921 18.786 4.87378 19.3256 5.26442 19.7191C5.65506 20.1126 6.19069 20.3488 7.11973 20.4744C8.06909 20.6028 9.31951 20.6047 11.0806 20.6047H12.9276C14.6887 20.6047 15.9401 20.6028 16.8894 20.4744C17.8175 20.3488 18.3532 20.1126 18.7438 19.7191C19.3866 19.0716 19.5814 18.066 19.6147 15.7107C19.6174 15.5257 19.6929 15.3493 19.8247 15.2204C19.89 15.1565 19.9671 15.1063 20.0516 15.0724C20.1362 15.0386 20.2265 15.0219 20.3175 15.0233C20.4084 15.0246 20.4982 15.044 20.5817 15.0803C20.6653 15.1166 20.7409 15.1691 20.8042 15.2348C20.8676 15.3006 20.9175 15.3782 20.9511 15.4634C20.9847 15.5486 21.0013 15.6395 20.9999 15.7312C20.9676 17.9888 20.8226 19.5991 19.7236 20.706C19.0319 21.4019 18.1555 21.7107 17.0732 21.8577C16.0204 22 14.6767 22 12.9793 22H11.0289C9.33151 22 7.9869 22 6.93503 21.8577C5.85269 21.7107 4.97629 21.4019 4.28459 20.706C3.59381 20.0093 3.28721 19.1265 3.1413 18.0363C3 16.9758 3 15.6223 3 13.9126V10.0874C3 8.37767 3 7.02326 3.1413 5.96372C3.28721 4.87349 3.59381 3.9907 4.28459 3.29395C4.97629 2.59814 5.85269 2.2893 6.93503 2.14233C7.98782 2 9.33151 2 11.0289 2Z"
                fill="black"
              />
              <path
                d="M6.21967 9.18499C6.07902 9.30343 6 9.46407 6 9.63158C6 9.79908 6.07902 9.95973 6.21967 10.0782C6.36032 10.1966 6.55109 10.2632 6.75 10.2632H13.25C13.4489 10.2632 13.6397 10.1966 13.7803 10.0782C13.921 9.95973 14 9.79908 14 9.63158C14 9.46407 13.921 9.30343 13.7803 9.18499C13.6397 9.06654 13.4489 9 13.25 9H6.75C6.55109 9 6.36032 9.06654 6.21967 9.18499Z"
                fill="#808898"
              />
              <path
                d="M6.21967 12.5534C6.07902 12.6719 6 12.8325 6 13C6 13.1675 6.07902 13.3281 6.21967 13.4466C6.36032 13.565 6.55109 13.6316 6.75 13.6316H9.25C9.44891 13.6316 9.63968 13.565 9.78033 13.4466C9.92098 13.3281 10 13.1675 10 13C10 12.8325 9.92098 12.6719 9.78033 12.5534C9.63968 12.435 9.44891 12.3684 9.25 12.3684H6.75C6.55109 12.3684 6.36032 12.435 6.21967 12.5534Z"
                fill="#808898"
              />
              <path
                d="M6.21967 15.9218C6.07902 16.0403 6 16.2009 6 16.3684C6 16.5359 6.07902 16.6966 6.21967 16.815C6.36032 16.9335 6.55109 17 6.75 17H8.25C8.44891 17 8.63968 16.9335 8.78033 16.815C8.92098 16.6966 9 16.5359 9 16.3684C9 16.2009 8.92098 16.0403 8.78033 15.9218C8.63968 15.8034 8.44891 15.7368 8.25 15.7368H6.75C6.55109 15.7368 6.36032 15.8034 6.21967 15.9218Z"
                fill="#808898"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.5406 6.80026C18.7788 6.55093 19.0645 6.35171 19.3808 6.21432C19.697 6.07692 20.0376 6.00411 20.3824 6.00017C20.7272 5.99623 21.0694 6.06123 21.3887 6.19136C21.708 6.32149 21.9982 6.51412 22.242 6.75794C22.4858 7.00176 22.6785 7.29185 22.8086 7.61116C22.9388 7.93047 23.0038 8.27257 22.9998 8.61736C22.9959 8.96215 22.9231 9.30267 22.7857 9.61893C22.6483 9.93518 22.449 10.2208 22.1997 10.459L17.6697 14.9914C17.4813 15.19 17.2808 15.3767 17.0694 15.5507C16.8496 15.7222 16.6133 15.8683 16.3605 15.989C16.147 16.0909 15.9222 16.1652 15.5925 16.2748L13.6067 16.937C13.3917 17.0089 13.1608 17.0195 12.9401 16.9675C12.7194 16.9156 12.5176 16.8031 12.3572 16.6428C12.1969 16.4825 12.0844 16.2806 12.0325 16.06C11.9805 15.8393 11.9911 15.6085 12.063 15.3935L12.7119 13.4498L12.7253 13.4088C12.8358 13.0782 12.9101 12.8543 13.0121 12.6409C13.1318 12.3892 13.2788 12.1515 13.4504 11.932C13.5962 11.7452 13.7629 11.5785 14.0097 11.3317L14.0393 11.3022L18.5406 6.80026ZM21.1896 7.81021C21.082 7.70258 20.9543 7.6172 20.8137 7.55895C20.6731 7.5007 20.5224 7.47072 20.3702 7.47072C20.218 7.47072 20.0673 7.5007 19.9267 7.55895C19.786 7.6172 19.6583 7.70258 19.5507 7.81021L19.3773 7.98362L19.4097 8.08557C19.4992 8.34282 19.6698 8.68583 19.9919 9.00787C20.2769 9.29476 20.6289 9.50599 21.0162 9.62242L21.1896 9.44901C21.2973 9.34142 21.3827 9.21368 21.4409 9.07308C21.4992 8.93249 21.5292 8.7818 21.5292 8.62961C21.5292 8.47743 21.4992 8.32673 21.4409 8.18614C21.3827 8.04555 21.2973 7.9178 21.1896 7.81021ZM19.9242 10.7143C19.5758 10.5325 19.2576 10.2979 18.9809 10.0188C18.7018 9.7421 18.4671 9.42392 18.2853 9.07552L15.0493 12.3112C14.7625 12.598 14.6615 12.7009 14.5767 12.8095C14.4687 12.948 14.3769 13.0963 14.3013 13.2544C14.2422 13.3793 14.1956 13.5155 14.0669 13.9004L13.6858 15.0438L13.9554 15.3134L15.0989 14.9323C15.4838 14.8037 15.6201 14.757 15.7449 14.6979C15.9025 14.6217 16.0508 14.5299 16.1899 14.4226C16.2985 14.3378 16.4015 14.2368 16.6883 13.95L19.9242 10.7143Z"
                fill="#808898"
              />
            </svg>
          </>
        )
      case ICONS.PRODUCT_CATALOG:
        return (
          <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 2V8C8 9.10457 8.89543 10 10 10H14C15.1046 10 16 9.10457 16 8V2"
                stroke="#808898"
                stroke-width="1.5"
              />
              <path
                d="M16 21L16 15C16 13.8954 15.1046 13 14 13L10 13C8.89543 13 8 13.8954 8 15L8 21"
                stroke="#808898"
                stroke-width="1.5"
              />
              <rect
                x="2.75"
                y="2.75"
                width="18.5"
                height="18.5"
                rx="5.25"
                stroke="black"
                stroke-width="1.5"
              />
            </svg>
          </>
        )
      case ICONS.PRODUCT_NEW:
        return (
          <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.0001 8.5H14.0001M5.78211 4.182C6.43011 3.683 6.75411 3.434 7.12811 3.273C7.29811 3.20033 7.47378 3.14167 7.65511 3.097C8.05411 3 8.47711 3 9.32311 3H14.6771C15.5231 3 15.9471 3 16.3451 3.097C16.5271 3.14167 16.7028 3.20033 16.8721 3.273C17.2461 3.433 17.5701 3.683 18.2181 4.182C20.3641 5.834 21.4381 6.661 21.8061 7.731C21.9691 8.207 22.0301 8.707 21.9861 9.205C21.8861 10.323 21.0381 11.346 19.3431 13.393L15.3501 18.215C13.8131 20.072 13.0441 21 12.0001 21C10.9561 21 10.1871 20.072 8.65011 18.215L4.65711 13.393C2.96211 11.346 2.11511 10.323 2.01411 9.205C1.96953 8.70647 2.03087 8.20415 2.19411 7.731C2.56211 6.661 3.63611 5.835 5.78211 4.182Z"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </>
        )
      case ICONS.CATEGORIES:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.625 9.75C19.489 9.75 21 8.23896 21 6.375C21 4.51104 19.489 3 17.625 3C15.761 3 14.25 4.51104 14.25 6.375C14.25 8.23896 15.761 9.75 17.625 9.75Z"
              stroke="black"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.375 21C8.23896 21 9.75 19.489 9.75 17.625C9.75 15.761 8.23896 14.25 6.375 14.25C4.51104 14.25 3 15.761 3 17.625C3 19.489 4.51104 21 6.375 21Z"
              stroke="black"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.25 14.25H21V19.875C21 20.1734 20.8815 20.4595 20.6705 20.6705C20.4595 20.8815 20.1734 21 19.875 21H15.375C15.0766 21 14.7905 20.8815 14.5795 20.6705C14.3685 20.4595 14.25 20.1734 14.25 19.875V14.25ZM3 3H9.75V8.625C9.75 8.92337 9.63147 9.20952 9.42049 9.42049C9.20952 9.63147 8.92337 9.75 8.625 9.75H4.125C3.82663 9.75 3.54048 9.63147 3.32951 9.42049C3.11853 9.20952 3 8.92337 3 8.625V3Z"
              stroke="#808898"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        )
      case ICONS.MARKETING:
        return (
          <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.3847 3.32148C13.7051 2.00464 15.9399 3.14651 15.6453 4.98982L15.4876 5.97658C15.2533 7.44214 15.989 8.89209 17.3103 9.56799L18.1997 10.023C19.8607 10.8727 19.4639 13.3519 17.6215 13.641L16.6346 13.7959C15.1684 14.0259 14.0174 15.1742 13.7831 16.6398L13.6254 17.6265C13.3308 19.4693 10.8516 19.8579 10.0074 18.1944L9.55518 17.3033C8.8835 15.9798 7.43612 15.2393 5.96993 15.4694L6.0862 16.2103L5.96993 15.4694L4.98304 15.6242C3.14114 15.9133 2.00388 13.6751 3.32535 12.3571L4.03277 11.6515C5.08357 10.6035 5.34018 8.9979 4.66853 7.67445L4.21632 6.7834C3.3715 5.11872 5.14983 3.34723 6.80963 4.19631L7.69904 4.65129C9.02035 5.32722 10.6265 5.07514 11.6773 4.02704L12.3847 3.32148Z"
                stroke="#808898"
                stroke-width="1.5"
              />
              <path d="M17 17L22 22" stroke="#200E32" stroke-width="1.5" stroke-linecap="round" />
            </svg>
          </>
        )
      case ICONS.OFFERS:
        return (
          <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.4">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7 17V7.00003H11V17H7Z"
                  stroke="#200E32"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13 17V11H17V17H13Z"
                  stroke="#200E32"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <path
                d="M7.78265 3H16.2173C19.1695 3 21 5.09073 21 8.04287V15.9661C21 18.9182 19.1695 21 16.2173 21H7.78265C4.79462 21 3 18.9182 3 15.9661V8.04287C3 5.09073 4.83051 3 7.78265 3Z"
                stroke="#200E32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </>
        )
      case ICONS.FLYERS:
        return (
          <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.99023 16.9996L5.74023 13.7996C6.10008 13.4422 6.57234 13.2201 7.07711 13.1709C7.58188 13.1217 8.08815 13.2484 8.51023 13.5296C8.93232 13.8108 9.43859 13.9375 9.94335 13.8883C10.4481 13.8391 10.9204 13.617 11.2802 13.2596L13.6102 10.9296C14.2797 10.2578 15.1661 9.84582 16.1113 9.76705C17.0564 9.68829 17.9988 9.94792 18.7702 10.4996L21.2602 12.4296M7.99023 10.1696C8.20823 10.1696 8.42409 10.1267 8.62549 10.0432C8.82689 9.95983 9.00989 9.83755 9.16403 9.68341C9.31818 9.52926 9.44045 9.34626 9.52387 9.14486C9.6073 8.94346 9.65023 8.7276 9.65023 8.50961C9.65023 8.29162 9.6073 8.07576 9.52387 7.87435C9.44045 7.67295 9.31818 7.48996 9.16403 7.33581C9.00989 7.18167 8.82689 7.05939 8.62549 6.97597C8.42409 6.89255 8.20823 6.84961 7.99023 6.84961C7.54998 6.84961 7.12775 7.0245 6.81644 7.33581C6.50513 7.64712 6.33023 8.06935 6.33023 8.50961C6.33023 8.94987 6.50513 9.3721 6.81644 9.68341C7.12775 9.99472 7.54998 10.1696 7.99023 10.1696Z"
                stroke="#808898"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.2402 3.5H7.74023C6.41415 3.5 5.14238 4.02678 4.2047 4.96447C3.26702 5.90215 2.74023 7.17392 2.74023 8.5V15.5C2.74023 16.1566 2.86956 16.8068 3.12084 17.4134C3.37211 18.02 3.74041 18.5712 4.2047 19.0355C5.14238 19.9732 6.41415 20.5 7.74023 20.5H16.2402C16.8968 20.5 17.547 20.3707 18.1537 20.1194C18.7603 19.8681 19.3115 19.4998 19.7758 19.0355C20.2401 18.5712 20.6084 18.02 20.8596 17.4134C21.1109 16.8068 21.2402 16.1566 21.2402 15.5V8.5C21.2402 7.84339 21.1109 7.19321 20.8596 6.58658C20.6084 5.97995 20.2401 5.42876 19.7758 4.96447C19.3115 4.50017 18.7603 4.13188 18.1537 3.8806C17.547 3.62933 16.8968 3.5 16.2402 3.5Z"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </>
        )
      case ICONS.PROMOTIONS_NEW:
        return (
          <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="10" r="3.25" stroke="black" stroke-width="1.5" />
              <path d="M6 14L6 21.5L12 19.5L18 21.5V14" stroke="black" stroke-width="1.5" />
              <circle cx="12" cy="10" r="7.25" stroke="#808898" stroke-width="1.5" />
            </svg>
          </>
        )
      case ICONS.RATING_NEW:
        return (
          <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.04024 7.77148C3.58024 8.32848 2.35024 8.60648 2.05723 9.54748C1.76523 10.4875 2.60324 11.4685 4.28024 13.4295L4.71424 13.9365C5.19024 14.4935 5.42923 14.7725 5.53623 15.1165C5.64323 15.4615 5.60723 15.8335 5.53523 16.5765L5.46923 17.2535C5.21623 19.8705 5.08924 21.1785 5.85524 21.7595C6.62124 22.3405 7.77323 21.8105 10.0752 20.7505L10.6722 20.4765C11.3262 20.1745 11.6532 20.0245 12.0002 20.0245C12.3472 20.0245 12.6742 20.1745 13.3292 20.4765L13.9242 20.7505C16.2272 21.8105 17.3792 22.3405 18.1442 21.7605C18.9112 21.1785 18.7842 19.8705 18.5312 17.2535"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M19.7193 13.43C21.3963 11.47 22.2343 10.489 21.9423 9.548C21.6503 8.607 20.4193 8.328 17.9593 7.772L17.3233 7.628C16.6243 7.47 16.2753 7.391 15.9943 7.178C15.7133 6.965 15.5343 6.642 15.1743 5.996L14.8463 5.408C13.5793 3.136 12.9463 2 11.9993 2C11.0523 2 10.4193 3.136 9.15234 5.408"
                stroke="#808898"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </>
        )
      case ICONS.UPSELLING:
        return (
          <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.4">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7 17.0001V7.00006H11V17.0001H7Z"
                  stroke="#200E32"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13 17.0001V11.0001H17V17.0001H13Z"
                  stroke="#200E32"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <path
                d="M7.78265 3.00003H16.2173C19.1695 3.00003 21 5.09076 21 8.0429V15.9661C21 18.9183 19.1695 21 16.2173 21H7.78265C4.79462 21 3 18.9183 3 15.9661V8.0429C3 5.09076 4.83051 3.00003 7.78265 3.00003Z"
                stroke="#200E32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </>
        )
      case ICONS.CAMPAIGNS:
        return (
          <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="2.75"
                y="2.75"
                width="18.5"
                height="18.5"
                rx="3.25"
                stroke="black"
                stroke-width="1.5"
              />
              <path
                d="M9 11.5L11.3333 14L16 9"
                stroke="#808898"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </>
        )
      case ICONS.CASHBACK:
        return (
          <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 18C10.668 18.622 8.917 19 7 19C5.934 19 4.92 18.883 4 18.673C3.409 18.537 3.113 18.47 2.759 18.189C2.52733 17.9907 2.33558 17.7501 2.194 17.48C2 17.073 2 16.677 2 15.886V5.114C2 4.129 3.04 3.453 4 3.673C4.92 3.883 5.934 4 7 4C8.917 4 10.668 3.622 12 3C13.332 2.378 15.083 2 17 2C18.066 2 19.08 2.117 20 2.327C20.591 2.463 20.887 2.531 21.241 2.811C21.443 2.971 21.695 3.287 21.806 3.52C22 3.928 22 4.323 22 5.114V15.886C22 16.871 20.96 17.547 20 17.327C19.08 17.117 18.066 17 17 17C15.083 17 13.332 17.378 12 18Z"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.5 11.5V11.509M18.5 9.492V9.502M14.5 10.5C14.5 11.163 14.2366 11.7989 13.7678 12.2678C13.2989 12.7366 12.663 13 12 13C11.337 13 10.7011 12.7366 10.2322 12.2678C9.76339 11.7989 9.5 11.163 9.5 10.5C9.5 9.83696 9.76339 9.20107 10.2322 8.73223C10.7011 8.26339 11.337 8 12 8C12.663 8 13.2989 8.26339 13.7678 8.73223C14.2366 9.20107 14.5 9.83696 14.5 10.5Z"
                stroke="#808898"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2 21C3.333 21.622 5.083 22 7 22C8.917 22 10.668 21.622 12 21C13.332 20.378 15.083 20 17 20C18.917 20 20.668 20.378 22 21"
                stroke="#808898"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </>
        )
      default:
        return null
    }
  }

  return (
    <svg
      style={styles.svg}
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      onClick={onClick}
    >
      {renderPath()}
    </svg>
  )
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
}

Icon.defaultProps = {
  size: 24,
  color: 'currentColor',
}

export default Icon
